import { render } from "./LeeBadge.vue?vue&type=template&id=4a8aeb22"
import script from "./LeeBadge.vue?vue&type=script&lang=js"
export * from "./LeeBadge.vue?vue&type=script&lang=js"

import "./LeeBadge.vue?vue&type=style&index=0&id=4a8aeb22&lang=css"

import exportComponent from "F:\\leeao\\leeplus_docs_code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__